module.exports = __webpack_public_path__ + "img/17868_S.6eba45a0.png";